import React from 'react';

import { classnames } from '../../../utils/classnames';

import './box.css';

export function Box({ children, className }) {
	return (
		<div className={classnames('wz-neo-box', className)}>
			{children}
		</div>
	);
}

export function BoxContent({ children, className }) {
	return (
		<div className={classnames('box-content', className)}>
			{children}
		</div>
	);
}
